import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import SixMonthsInspectionPage from 'pages/app/six-months-inspection-page/SixMonthsInspectionPage'

const sixMonthsInspectionSearchSchema = z.object({
  mode: z.enum(['view', 'edit']).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/app/uppdrag/$uuid/sixm/$sixmid'
)({
  validateSearch: sixMonthsInspectionSearchSchema,
  component: SixMonthsInspectionPage,
})
